import { reducer as toastrReducer } from 'react-redux-toastr';
import { combineReducers } from 'redux';
import common from '~/store/ducks/common';
import ContactDPOLogado from '~/store/ducks/ContactDPOLogado';
import documents from '~/store/ducks/documents';
import EliminacaoAnonimizacao from '~/store/ducks/EliminacaoAnonimizacao';
import ExportarInformacoesOperacoes from '~/store/ducks/ExportarInformacoesOperacoes';
import consentimentos from '~/store/ducks/GerenciarConsentimento';
import language from '~/store/ducks/language';
import mostrarInformacoesPessoais from '~/store/ducks/MostrarInformacoesPessoais';
import theme from '~/store/ducks/theme';
import user from '~/store/ducks/user';
import appControllers from './appControllers';
import auth from './auth';

export default combineReducers({
  toastr: toastrReducer,
  appControllers,
  auth,
  user,
  language,
  theme,
  consentimentos,
  mostrarInformacoesPessoais,
  ContactDPOLogado,
  EliminacaoAnonimizacao,
  ExportarInformacoesOperacoes,
  documents,
  common,
});
